// removed by extract-text-webpack-plugin
module.exports = {"marketType":"_1nB4upc9v_JtpHWrMY1OUD","marketText":"Ci9tCi07CBS6XL_vpH4ta","customButtonContainer":"btFvgAjz6hO8_Vsa6-cxx","innerText":"_1q0sTCXC4lig9D14Nx-kXl"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/tennis/css/oddsCardTennis.css
// module id = 974
// module chunks = 0